<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    :editIcon="editIcon"
    :readOnly="readOnly"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :isTextButton="isTextButton"
    :textButton="textButton"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        id="printableELement"
        :readOnly="readOnly"
        @installment-update="loadServerEntry(entry.id)"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
    <!-- <template slot="action1">
      <BasePrint
        printableElementId="printableELement"
        printButtonLabel="Imprimir Prévia da Venda"
        printTitle="Prévia das Informações da Venda"
        @start-printing="pageLoading = true"
        @stop-printing="pageLoading = false"
      />
    </template> -->
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    // editTitle: {
    //   type: String,
    //   default: "Edição de Compra"
    // },
    // readTitle: {
    //   type: String,
    //   default: "Visualização de Compra"
    // },
    editIcon: {
      type: String,
      default: "mdi-pencil"
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isTextButton: {
      type: Boolean,
      default: false
    },
    textButton: {
      type: String,
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit,
    BasePrint: BasePrint
  },
  created() {
    console.log("edit purchase created");
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_PURCHASE_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.purchase;
          this.extraData = response.data;
          // console.log("purchase edit", this.editableEntry);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(purchase) {
      // console.log("PURCHASE", purchase, purchase.validations, this.deepFilterEntryWithAllowedFieldsForMutation(purchase, purchase.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_PURCHASE_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(purchase, purchase.validations)
          }
        })
        .then(response => {
          var errors = response.data.updatePurchase.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry)
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
      this.$emit("entry-canceled");
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_PURCHASE_QUERY = gql `
  query ($id: ID!) {
    accountContext {
      purchase(id: $id) {
        id
        cfopId
        code
        series
        number
        billDate
        estimatedDeliveryDate
        orderValidity
        supplierId
        customerId
        totalPrice
        validations
        totalCarriageValue
        totalDiscountValue
        totalInsuranceValue
        otherExpensesTotalValue
        observation
        dummyEntryMovementItemsAttributes {
          id
          price
          unitPrice
          quantity
          packagingQuantity
          itemId
          hasLot
          enabledLots
          item {
            id
            name
            description
            unit {
              name
            }
          }
          dummyEntryMovementItemLotsAttributes{
            id
            name
            dueDate
            manufacturingDate
            lotNumber
            manufacturingLotId
            quantity
            packagingQuantity
          }
          packagingId
          packaging {
            id
            name
            unitName
            size
            text
          }
          storageId
          storage {
            id
            name
            location
          }
          validations
        }
        paymentsAttributes {
          id
          code
          bankAccountId
          paymentMethodId
          value
          initialDate
          installmentsIntervalId
          installmentsInterval {
            id
            description
            intervalInDays
          }
          paymentConditionId
          paymentCondition {
            id
            description
            numberOfInstallments
          }
          paymentMethod {
            id
            name
          }
          bankAccount {
            id
            name
          }
          installmentsAttributes {
            id
            value
            originalValue
            customCode
            dueDate
            code
            status
            statusKey
            statusColor
            paidAmount
            paymentDate
            bankAccount {
              id
              name
            }
          }
        }
      }
      allSuppliers {
        id
        name
      }
      allCollaborators{
        id
        name
      }
      allPurchaseCfops{
        id
        text
      }
    }
  }
`;

const UPDATE_PURCHASE_MUTATION = gql `
  mutation($input: PurchaseUpdateInputObject!) {
    updatePurchase(input: $input) {
      cashFlow {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
